import { useState } from 'react';
import { QuoteService } from 'services/quote.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

export const useQuoteResponsible = () => {
  const [isLoading, setIsLoading] = useState(false);

  const assignResponsible = (quoteId: number, userId: number) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      QuoteService.assignResponsible(quoteId, userId)
        .then(resolve)
        .catch(() => {
          reject();
          displayErrorNotification();
        })
        .finally(() => setIsLoading(false));
    });
  };

  const unassignResponsible = (id: number) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      QuoteService.unassignResponsible(id)
        .then(resolve)
        .catch(() => {
          reject();
          displayErrorNotification();
        })
        .finally(() => setIsLoading(false));
    });
  };

  /** Trae los responsables vigentes de una cotización para refrescar el estado local. */
  const getResponsibles = (quoteId: number) => {
    return QuoteService.getQuoteResponsibles(quoteId).catch(() => {
      displayErrorNotification();
      return [];
    });
  };

  return { isLoading, assignResponsible, unassignResponsible, getResponsibles };
};
